<script setup lang="ts">
import { isOtherThemeHappy, isThemeHappy, theme } from '@/event/theme/theme'
</script>

<template>
    <section
        :class="{
            'copyright-default': theme === 'default',
            'copyright-happy': isThemeHappy || isOtherThemeHappy
        }"
    >
        <div
            :class="{
                'div-copyright-default': theme === 'default',
                'div-copyright-happy': isThemeHappy || isOtherThemeHappy
            }"
        >
            <p>© 2025 Eronor. {{ $t('allRightsReserved') }}.</p>
        </div>
    </section>
</template>

<style scoped>
.copyright-default {
    @apply px-6 bg-black;
}

.copyright-happy {
    @apply w-full;
    @apply happy-ifo-dark:text-t-accent;
}
.div-copyright-default {
    @apply w-full text-center border-t-[0.1px] border-gray-600 py-2;
}
.div-copyright-happy {
    @apply w-full text-center border-t-[0.1px] border-gray-600 pt-4;
}

@media screen and (min-width: 800px) {
    .copyright-happy {
        @apply col-start-3;
    }
    .div-copyright-happy {
        @apply border-t-0;
    }
}
</style>
